// 门店跟踪-门店摄像头管理
export default {
  meta: {
    title: '门店客流管理',
    url: '/stores/manage', // 埋点用，记录所属模块
    // eventId: '073d60a3-24c3-4e75-9a9d-841d3ad50257'
  },
};
